import { OdBaseDragger } from "../Draggers/Common/OdBaseDragger";
import { EventListener } from "../EventEmitter2";
import { Viewer } from "../Viewer";
import { IMarkupObject } from "./Api/IMarkupObject";

export enum MarkupType {
  Unknown,
  Konva = "Konva",
  Visualize = "Visualize",
}

export enum MarkupMode {
  Line = "Line",
  Text = "Text",
}

export interface IMarkup {
  lineWidth: number;

  initialize(viewer: Viewer, canvas: HTMLCanvasElement, canvasEvents: string[], eventEmit: EventListener): void;
  getDraggers(): Map<string, typeof OdBaseDragger>;
  resizeCanvas(): void;
  clearOverlay(): void;
  getMarkupColor(): { r: number; g: number; b: number };
  setMarkupColor(r: number, g: number, b: number): void;
  colorizeAllMarkup(r: number, g: number, b: number): void;
  drawViewpoint(viewpoint: any): void;
  createViewpoint(): object;
  dispose(): void;

  createObject(type: string, params: any): IMarkupObject;
  addObject(object: IMarkupObject): void;
  getObjects(): IMarkupObject[];
  getSelectedObjects(): IMarkupObject[];
  selectObjects(objects: IMarkupObject[]): void;
  clearSelected(): void;
}
